import useNetwork from './network';
import { ILocationModel } from './models/locationModel';

export const createLocation = async (lang: string, id: number, details: ILocationModel) => {
    const { createLocation } = useNetwork();
    const result = await createLocation(lang, id, details);

    if (result.status === 201) {
        return (await result.json()) as ILocationModel;
    }
};

export const updateLocations = async (lang: string, id: number, details: ILocationModel[]) => {
    const { updateLocations } = useNetwork();
    const result = await updateLocations(lang, id, details);

    if (result.status === 200) {
        return (await result.json()) as ILocationModel[];
    }
};

export const deleteLocation = async (lang: string, accountId: number, locationId: number) => {
    const { deleteALocation } = useNetwork();
    const result = await deleteALocation(lang, accountId, locationId);

    if (result.status === 200) {
        return (await result.json()) as ILocationModel;
    }
};
